import { ICONS } from "../ui/icons";

const projects = [
  { key: "showers-walk-in-tubs", slug: "showers-walk-in-tubs", label: "Showers / Walk-In Tubs", icon: ICONS.walkInTubs, environment: "indoor" },
  { key: "windows-replacement", slug: "windows-replacement", label: "Windows & Doors", icon: ICONS.windowReplacement, environment: "both" },
  { key: "washers-dryers", slug: "washers-dryers", label: "Washers / Dryers", icon: ICONS.washersDryers, environment: "indoor" },
  { key: "rain-gutters", slug: "rain-gutters", label: "Rain Gutters", icon: ICONS.gutterGuards, environment: "outdoor" },
  { key: "roofing", slug: "roofing", label: "Roofing", icon: ICONS.roofing, environment: "outdoor" },
  { key: "home-siding-paneling", slug: "home-siding-paneling", label: "Home Siding / Paneling", icon: ICONS.siding, environment: "outdoor" },
  { key: "hvac", slug: "hvac", label: "HVAC / Mini-Splits", icon: ICONS.hvac, environment: "both" },
  { key: "deck-installation", slug: "deck-installation", label: "Decks", icon: ICONS.decks, environment: "outdoor" },
  { key: "waterproofing", slug: "waterproofing", label: "Waterproofing", icon: ICONS.basementWaterproofing, environment: "both" },
  { key: "flooring", slug: "flooring", label: "Flooring", icon: ICONS.flooring, environment: "indoor" },
  { key: "kitchen-cabinet-refacing", slug: "kitchen-cabinet-refacing", label: "Kitchen Cabinet Refacing", icon: ICONS.kitchenCabinetRefacing, environment: "indoor" },
  { key: "bathroom-remodeling", slug: "bathroom-remodeling", label: "Bathroom Remodeling", icon: ICONS.bathroomRemodeling, environment: "indoor" },
  { key: "concrete-foundation", slug: "concrete-foundation", label: "Concrete / Foundation", icon: ICONS.concreteFoundation, environment: "both" },
  { key: "concrete-sealing-coating", slug: "concrete-sealing-coating", label: "Driveway / Patio Resurfacing", icon: ICONS.concreteFloorCoating, environment: "outdoor" },
  // AUTO-GENERATED CATEGORY PROJECTS START
  { key: "adus", slug: "adus", label: "ADUs", icon: ICONS.ADUs, environment: "outdoor" },
  { key: "electrical", slug: "electrical", label: "Electrical", icon: ICONS.electrical, environment: "indoor" },
  { key: "fence-gates", slug: "fence-gates", label: "Fence / Gates", icon: ICONS.fenceGates, environment: "outdoor" },
  { key: "junk-removal", slug: "junk-removal", label: "Junk Removal", icon: ICONS.junkRemoval, environment: "both" },
  { key: "landscaping", slug: "landscaping", label: "Landscaping / Tree Services", icon: ICONS.landscaping, environment: "outdoor" },
  { key: "plumbing", slug: "plumbing", label: "Plumbing", icon: ICONS.plumbing, environment: "indoor" },
  { key: "pools", slug: "pools", label: "Pools / Pool Service", icon: ICONS.pools, environment: "outdoor" },
  { key: "water-heaters", slug: "water-heaters", label: "Water Heaters", icon: ICONS.waterHeaters, environment: "indoor" },
  // AUTO-GENERATED CATEGORY PROJECTS END
  { key: "standby-generators", slug: "standby-generators", label: "Backup Generator Install", icon: ICONS.standbyGenerators, environment: "outdoor" },
  { key: "water-treatment-systems", slug: "water-treatment-systems", label: "Ozone Water Treatment Systems", icon: ICONS.waterTreatmentSystems, environment: "indoor" },
  { key: "sunrooms-and-enclosures", slug: "sunrooms-and-enclosures", label: "Sunrooms & Enclosures", icon: ICONS.sunroomsAndEnclosures, environment: "both" }
];

const PRIORITY_CATEGORY_ORDER = [
  "roofing",
  "plumbing",
  "hvac",
  "water-treatment-systems",
  "bathroom-remodeling",
  "adus",
  "electrical",
  "windows-replacement",
  "deck-installation",
  "concrete-foundation",
  "flooring",
  "fence-gates",
  "home-siding-paneling",
  "concrete-sealing-coating",
  "waterproofing",
  "landscaping"
];

const priorityIndexByKey = new Map(
  PRIORITY_CATEGORY_ORDER.map((key, index) => [key, index])
);

const originalIndexByKey = new Map(
  projects.map((project, index) => [project.key, index])
);

const orderedProjects = [...projects].sort((a, b) => {
  const aPriority = priorityIndexByKey.has(a.key)
    ? priorityIndexByKey.get(a.key)
    : Number.MAX_SAFE_INTEGER;
  const bPriority = priorityIndexByKey.has(b.key)
    ? priorityIndexByKey.get(b.key)
    : Number.MAX_SAFE_INTEGER;

  if (aPriority !== bPriority) {
    return aPriority - bPriority;
  }

  return originalIndexByKey.get(a.key) - originalIndexByKey.get(b.key);
});

export const getProjectsForBrand = (brandKey) => {
  const allowedEnvironments =
    brandKey === "house-helper"
      ? ["outdoor", "both"]
      : ["indoor", "both"];

  return orderedProjects.filter((project) =>
    allowedEnvironments.includes(project.environment)
  );
};

export const getOppositeBrandKey = (brandKey) =>
  brandKey === "house-helper" ? "home-helper" : "house-helper";

export const getCrossSiteProjectsForBrand = (brandKey) => {
  const currentProjects = getProjectsForBrand(brandKey);
  const targetProjects = getProjectsForBrand(getOppositeBrandKey(brandKey));
  const currentSlugs = new Set(currentProjects.map((project) => project.slug));

  return targetProjects.filter((project) => !currentSlugs.has(project.slug));
};

export default orderedProjects;
